<template>
  <div class="page-content">
    <div class="page-title">
      <h5>更新开题报告</h5>
    </div>
    <div class="panel">
      <div class="">
        <div class="normal tm_navbuttons">
          <el-button type="primary" size="mini" @click="myThesisProposal()"
            >我的开题报告</el-button
          >
        </div>
        <el-form
          id="form_thesisProposal_add"
          :model="form"
          :rules="rules"
          ref="ruleForm"
          :inline-message="true"
        >
          <input type="hidden" name="wx_id" value="" />
          <table width="100%" cellpadding="5" border="0" class="tm_table_form">
            <tbody>
              <template v-if="configs">
                <tr>
                  <th style="width: 200px">批次 :</th>
                  <td>
                    <el-select v-model="defaultThesisBatchId" @change="getInfo">
                      <el-option
                        v-for="item in configs"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </td>
                </tr>
              </template>

              <tr>
                <th><span class="xw_required">*</span>论文方向 :</th>
                <td>
                  <el-form-item prop="direction">
                    <el-input
                      v-model="form.direction"
                      placeholder=""
                      style="width: 100%"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <th style="width: 200px">
                  <span class="xw_required">*</span>选题类型 :
                </th>
                <td>
                  <el-select v-model="sTopic" @change="sTopicChange" disabled>
                    <el-option label="自拟题目" value="1"> </el-option>
                    <el-option label="选题" value="2"> </el-option>
                  </el-select>
                  <el-select
                    style="margin-left: 10px"
                    v-if="sTopic == 2"
                    v-model="form.questionId"
                    placeholder="请选择"
                    filterable
                    disabled
                  >
                    <el-option
                      v-for="item in topicList"
                      :key="item.tqId"
                      :label="item.tqContent"
                      :value="item.tqId"
                    >
                    </el-option>
                  </el-select>
                </td>
              </tr>

              <tr>
                <th><span class="xw_required">*</span>题目 :</th>
                <td>
                  <el-form-item prop="title">
                    <div v-show="sTopic == 1">
                      <el-input
                        v-model="form.title"
                        placeholder=""
                        style="width: calc(100% - 320px)"
                        maxlength="1000"
                      ></el-input>
                      <el-button
                        type="primary"
                        size="mini"
                        class="ml"
                        @click="checkTitleExists()"
                        >校验题目是否重复</el-button
                      >
                    </div>
                    <div v-show="sTopic == 2">
                      <el-input
                        v-model="form.title"
                        placeholder=""
                        style="width: 100%"
                        maxlength="1000"
                        disabled
                      ></el-input>
                    </div>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <th>
                  <span class="xw_required">*</span>
                  一.本题的根据(不得少于100字)<br />
                  1.说明本题的理论及实际意义<br />
                  2.综述国内外有关本题的动态和自己的见解 :
                </th>
                <td>
                  <el-form-item prop="outline1">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder=""
                      v-model="form.outline1"
                    >
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <th>
                  <span class="xw_required">*</span
                  >二.本题的主要内容(不得少于100字):
                </th>
                <td>
                  <el-form-item prop="outline2">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder=""
                      v-model="form.outline2"
                    >
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <th>
                  <span class="xw_required">*</span
                  >三.完成期限和采取主要措施(不得少于100字):
                </th>
                <td>
                  <el-form-item prop="outline3">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder=""
                      v-model="form.outline3"
                    >
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <th>
                  <span class="xw_required">*</span
                  >四.主要参考文献书目(不得少于100字):
                </th>
                <td>
                  <el-form-item prop="outline4">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder=""
                      v-model="form.outline4"
                    >
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <th></th>
                <td>
                  <span class="red"
                    >请关注主考学校论文考核及论文质量要求。一般不少于15篇（设计类和软件类不少于10篇）。</span
                  >
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <th></th>
                <td>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="submitThesisProposal()"
                    >提交</el-button
                  >
                  <el-button size="mini" @click="$router.go(-1)"
                    >取消</el-button
                  >
                </td>
              </tr>
            </tfoot>
          </table>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.sTopic == "1") {
        //自拟
        if (this.form.title) {
          callback();
        } else {
          callback(new Error("请输入题目"));
        }
      } else if (this.sTopic == "2") {
        //选题
        if (this.form.questionId) {
          if (this.form.title) {
            callback();
          } else {
            callback(new Error("请输入题目"));
          }
        } else {
          callback(new Error("请选择题目"));
        }
      }
    };
    return {
      configs: [],
      info: {},
      defaultThesisBatchId: "",
      config: {},
      thesisProposal: null,
      thesis: null,
      db: null,
      logs: [],
      bm: null,
      curTime: "",
      nowDate: new Date().getTime(),
      form: {
        direction:''
      },
      sTopic: "1",
      topicList: [],
      rules: {
        direction: [
          { required: true, message: "填写论文方向", trigger: "blur" },
        ],
        title: [{ validator: validatePass, trigger: ["blur", "change"] }],
        outline1: [
          { required: true, message: "填写本题的根据", trigger: "blur" },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline2: [
          { required: true, message: "填写本题的主要内容", trigger: "blur" },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline3: [
          {
            required: true,
            message: "填写完成期限和采取主要措施",
            trigger: "blur",
          },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline4: [
          { required: true, message: "填写主要参考文献书目", trigger: "blur" },
          { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
      },
      isDisTitle: false,
      curT: null,
    };
  },
  created() {
    if (this.$route.query.thesisBatchId)
      this.defaultThesisBatchId = +this.$route.query.thesisBatchId;
    this.getInfo();
    this.curT = setInterval(() => {
      this.$http.post_s("/student/thesis2/getCurTime");
    }, 1000 * 60);
  },
  destroyed() {
    if (this.curT) {
      clearInterval(this.curT);
      this.curT = null;
    }
  },
  methods: {
    getTopicList() {
      let courseId = null;
      if (this.bm && this.bm.courseId) {
        courseId = this.bm.courseId;
      } else if (this.thesisProposal && this.thesisProposal.courseId) {
        courseId = this.thesisProposal.courseId;
      }

      this.$http
        .post("/student/thesisProposal2/thesisProposalTopic", {
          thesisBatchId: this.defaultThesisBatchId,
          courseId: courseId,
          questionUse: "has",
        })
        .then((res) => {
          this.topicList = res || [];
        });
    },
    getInfo() {
      this.$http
        .post("/student/thesis2/myThesis", { thesisBatchId: this.defaultThesisBatchId })
        .then((res) => {
          this.config = res.config;
          this.configs = res.configs;
          this.info = res;
          if (!this.defaultThesisBatchId)
            this.defaultThesisBatchId = res.defaultThesisBatchId;
          this.thesisProposal = res.thesisProposal;
          this.thesis = res.thesis;
          this.db = res.db;
          this.bm = res.bm;
          this.logs = res.logs;
          this.curTime = res.curTime;
          this.reportLogId = res.reportLogId;
          this.sTopic = this.thesisProposal.questionId ? "2" : "1";
          this.form = {
            thesisBatchId: res.defaultThesisBatchId,
            id: res.thesisProposal.id,
            direction: res.thesisProposal.direction,
            // title:this.thesisProposal.questionId?"": res.thesisProposal.title,
            title: res.thesisProposal.title,
            questionId: res.thesisProposal.questionId,
            outline1: res.thesisProposal.outline1,
            outline2: res.thesisProposal.outline2,
            outline3: res.thesisProposal.outline3,
            outline4: res.thesisProposal.outline4,
          };
          this.getTopicList();
        });
    },
    submitThesisProposal() {
      const _t = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = {
            ..._t.form,
            thesisBatchId: _t.defaultThesisBatchId,
          };
          if (this.sTopic == "1") {
            params.questionId = "";
          }
          _t.$http
            .post("/student/thesisProposal2/update", params)
            .then((res) => {
              if (res) {
                this.$message({
                  showClose: true,
                  message: "操作成功。",
                  type: "success",
                });
                this.$router.push({
                  path: "/main/myThesisProposal",
                  query: { thesisBatchId: this.defaultThesisBatchId },
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    myThesisProposal() {
      this.$router.push({
        path: "/main/myThesisProposal",
        query: { thesisBatchId: this.defaultThesisBatchId },
      });
    },
    sTopicChange() {
      this.$refs.ruleForm.validateField("title");
    },
    checkTitleExists() {
      if (!this.form.title) {
        this.$message({
          showClose: true,
          message: "请输入题目！",
          type: "error",
        });
        return;
      }
      const params = {
        ...this.form,
        id: this.thesisProposal.id,
        title: this.form.title.trim()
      };
      this.$http
        .post("/student/thesisProposal2/checkTitleExists", params)
        .then((res) => {
          if (!res) {
            this.$message({
              showClose: true,
              message: "当前开题报告题目未重复。",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: "当前开题报告题目重复，请更换题目！",
              type: "error",
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.xw_required {
  color: #f00;
}
#form_thesisProposal_add {
  .el-form-item {
    margin-bottom: 0;
  }
  &::v-deep .el-form-item__label {
    background: #f5f5f5;
  }
}
.el-button {
  margin: 10px;
}
.ml {
  margin-left: 10px;
}
</style>
